import axios from 'axios';
import {API} from '@/services/url';

/**
 * Tipsoi Pay section.
 *
 * Every call takes BOTH a success and an error callback and always invokes exactly one of them.
 * Omitting the error callback throws inside the caller's created() hook and takes the whole page
 * down — that has bitten this codebase before.
 */
export default {

	getSummary: function (success, error) {
		axios.get(API.pay.summary)
			.then(r => success(r.data))
			.catch(e => error(readMessage(e, 'Could not load the Tipsoi Pay summary')));
	},

	getClients: function (params, success, error) {
		axios.get(API.pay.clients, {params: params})
			.then(r => success(r.data))
			.catch(e => error(readMessage(e, 'Could not load Tipsoi Pay clients')));
	},

	/**
	 * The item catalogue is proxied by the office endpoint, which keeps the billing APIKEY
	 * server-side. Reused as-is rather than duplicated under /pay.
	 */
	getItems: function (success, error) {
		axios.get(API.office.billingItems)
			.then(r => success((r.data && r.data.items) ? r.data.items : []))
			.catch(e => error(readMessage(e, 'Could not load Tipsoi Pay items')));
	}
};

function readMessage(e, fallback) {
	if (e && e.response && e.response.data && e.response.data.message) return e.response.data.message;
	if (e && e.message) return e.message;
	return fallback;
}
